import { ProvisionBillingPreview } from "../../../../../store/slices/ProvisionBillingPreviewSlice";
import BillingDateSummary from "./BillingDateSummary/BillingDateSummary";
import LearnAboutBillingPeriods from "./LearnAboutBillingPeriods/LearnAboutBillingPeriods";
import ProvisionDatePicker from "./ProvisionDatePicker/ProvisionDatePicker";
import SkuProvisionSummary from "./SkuProvisionSummary/SkuProvisionSummary";
import { ProvisionDisplayDetails } from "../types";

interface CompletionStepProps {
  details: ProvisionDisplayDetails;
  selectedDate: Date | null;
  preview: ProvisionBillingPreview | null;
  previewStatus: "idle" | "loading" | "succeeded" | "failed";
  previewError: string | null;
  onDateChange: (date: Date | null) => void;
}

const CompletionStep = ({
  details,
  selectedDate,
  preview,
  previewStatus,
  previewError,
  onDateChange,
}: CompletionStepProps) => (
  <>
    <p className="sku-provision-intro">
      The following SKU will be marked as <strong>Complete</strong>.
    </p>
    <SkuProvisionSummary details={details} />
    <p className="sku-provision-guidance">
      Select a <strong>provision completion date</strong> to view the
      corresponding{" "}
      {details.interval === "One Time" ? "billing date" : "billing period"}.{" "}
      <span className="sku-provision-warning">
        <strong>Important:</strong> This completion date is final and cannot be
        updated later.
      </span>
    </p>
    <ProvisionDatePicker
      selectedDate={selectedDate}
      onDateChange={onDateChange}
    />
    <BillingDateSummary
      interval={details.interval}
      preview={preview}
      status={previewStatus}
      error={previewError}
    />
    <LearnAboutBillingPeriods />
  </>
);

export default CompletionStep;
